// src/components/Header.js
import { Link, useLocation } from 'react-router-dom';
import { useEffect, useState } from 'react';
import '../styles/header.css';

const Header = () => {
    const [menuOpen, setMenuOpen] = useState(false);
    const [data, setData] = useState(null);
    const [cargando, setCargando] = useState(true);
    const [error, setError] = useState(false);

    const location = useLocation();

    useEffect(() => { setMenuOpen(false); }, [location.pathname]);

    useEffect(() => {
        let cancel = false;
        (async () => {
            try {
                const r = await fetch('/data/header.json', { cache: 'no-store' });
                if (!r.ok) throw new Error('HTTP ' + r.status);
                const json = await r.json();
                if (!cancel) setData(json);
            } catch (e) {
                console.error('[Header] Error cargando /data/header.json:', e);
                if (!cancel) setError(true);
            } finally {
                if (!cancel) setCargando(false);
            }
        })();
        return () => { cancel = true; };
    }, []);

    if (cargando || !data) {
        return <header aria-busy="true" style={{ minHeight: 60 }} />;
    }

    if (error) {
        return <header><p role="alert">{data.ui?.loadError}</p></header>;
    }

    return (
        <header>
            <div className='main-wrapper header-inner'>
                <a href='/'>
                    <img src={data.brand.logo} alt={data.brand.logoAlt} />
                </a>
                <div className="menu-toggle" onClick={() => setMenuOpen(!menuOpen)}>
                    <span></span>
                    <span></span>
                    <span></span>
                </div>
                <nav>
                    <ul className={menuOpen ? "active" : ""}>
                        {data.nav.links.map((l, i) => (
                            <li key={i}><Link to={l.to}>{l.label}</Link></li>
                        ))}
                    </ul>
                </nav>
            </div>
        </header>
    );
};

export default Header;
